import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useSessionStore = create()(
    persist(
        (set, get) => ({
            session: false,
            token: '',
            user: '',
            start: (val) => set({ token: val }),
            end: (val) => set({ token: "" }),
            setUser: (val) => set({ user: val }),
        }),
        {
            name: 'session_storage', // name of the item in the storage (must be unique)
            storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
        },
    ),
)